module.exports = __webpack_public_path__ + "static/media/Manage_Category.9f5939b1.png";